import type { FunctionComponent } from 'react';

import { useAutoplaySlice } from '../../../../store/slices/autoplay/selectors';
import { L12nText } from '../../../text/L12nText';
import { TrafficLightRendererProps } from '../types';

export const PlaceBetsRendererConnected: FunctionComponent<TrafficLightRendererProps> = ({ timer }) => {
  const isAutoplayInProgress = useAutoplaySlice.isInProgress();
  const remainingAutoplayCount = useAutoplaySlice.getRemainingCount();

  if (isAutoplayInProgress && remainingAutoplayCount > 0) {
    return <L12nText tk="AUTOPLAY_LEFT" dynamicValues={[remainingAutoplayCount.toString()]} />;
  }

  return (
    <>
      <L12nText tk="PLACE_YOUR_BETS" />
      <>{timer}</>
    </>
  );
};
